<template>
  <popup ref="popup" :loading="popupLoading" :appendToBody="true">
    <div slot="body">
      <el-form class="dataForm" ref="form" :model="formParameter" :inline="true" label-width="60px" :rules="rules">
        <el-row>
          <el-col :span="16">
            <el-form-item label="">
           
              <b v-if="formParameter.sex=='女'"  style="font-size: 22px;color:deeppink;">{{ formParameter.name }}</b>
              <b v-else style="font-size: 22px;color: blue;">{{ formParameter.name }}</b>
              <span v-if="formParameter.hasresume">&nbsp;&nbsp;有简历
                <el-image title="有时看不见点要点多几次" style="width:59px; height: 25px" :src="'/static/shresume.png'"
                :preview-src-list="[(baseUrl + '/statics/resume24364/' + formParameter.mobile + '.jpg?' + Math.random())]">
              </el-image>
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上门" prop="interviewtime">
              <el-date-picker v-model="formParameter.interviewtime" type="datetime" placeholder="如成功邀约上门，则选填时间"
                default-time="14:00:00">
              </el-date-picker></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-table class="table" :data="parameter" stripe border height="auto">
              <el-table-column label="序号" width="60px" type="index">
                <template slot-scope="scope">
                  {{ idx + 1 }}/{{ sizeConus }}
                </template>
              </el-table-column>
              <el-table-column prop="mobile" label="电话" min-width="75px"></el-table-column>
              <el-table-column prop="name" label="电邀" width="75px">
                <template slot-scope="scope">

                  <el-tag type="warning" size="mini" v-if="scope.row.dyer">{{ scope.row.dyer }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="state" min-width="80px" label="数据状态">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.state" placeholder="请选择">

                    <el-option v-for="item in ['可跟进', '想培训', '无意向', '已上门', '已体验测评', '已报名', '未接通', '废量']" :key="item"
                      :label="item" :value="item">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="rank" label="意愿评价" min-width="80px">
                <template slot-scope="scope">
                  <el-rate show-text :max="4" v-model="scope.row.rank" :texts="['D', 'C', 'B', 'A']"></el-rate>
                </template>
              </el-table-column>
              <el-table-column min-width="70px" prop="city" label="当前所在城市">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.city" autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column min-width="300px" prop="remark" label="电邀信息反馈">
                <template slot-scope="scope">
                  <el-input type="textarea" :rows="3" v-model="scope.row.txt" autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="hasresume" width="110px" label="">
                <template slot-scope="scope">
                  <el-button type="primary"   :loading="confirmLoading" @click="confirm()">提 交</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="formParameter.sex" placeholder="请选择">
                <el-option v-for="item in ['男', '女']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
             </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="意向" prop="post">
              <el-select v-model="formParameter.post" placeholder="请选择">
                <el-option v-for="item in ['全栈', '后端', '前端']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
              </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="学校" prop="interviewtime">
              <el-input v-model="formParameter.schoolid" autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="学历" prop="grade">
              <el-select v-model="formParameter.grade" placeholder="请选择">
                <el-option v-for="item in ['本科', '大专', '研究生', '低学历']" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="专业" prop="interviewtime">
              <el-input v-model="formParameter.subject" autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="毕业" prop="gradedate">
              <el-date-picker v-model="formParameter.gradedate" value-format="yyyy" type="year" placeholder="选择年">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="19">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="formParameter.remark" autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button  type="success" size="mini"   v-has-permission-code-and="'100000150085'"
              @click="updated()"  >更新信息</el-button>
              <el-button v-has-permission-code-and="'1000001501000'" type="primary" size="medium"
                @click="toTest()">做题</el-button>
              <el-button v-has-permission-code-and="'1000001501005'" type="warning" size="medium"
                @click="toHelp()">辅助</el-button>
              
          </el-col>
        </el-row>
      </el-form>

      <el-table class="table" :data="listRecords" stripe border height="auto">
        <el-table-column label="序号" width="50px" type="index">
          <template slot-scope="scope">
            {{ sizeRecord - scope.$index }}
          </template>
        </el-table-column>
        <el-table-column prop="gjdate" label="跟进时间" width="140px">
        </el-table-column>
        <el-table-column prop="uid" width="70px" label="跟进人">
        </el-table-column>
        <el-table-column width="70px" prop="rank" label="评价">
          <template slot-scope="scope">
            <el-tag type="danger" size="mini" v-if="scope.row.rank == 1">D量</el-tag>
            <el-tag type="warning" size="mini" v-if="scope.row.rank == 2">C量</el-tag>
            <el-tag size="mini" v-if="scope.row.rank == 3">B量</el-tag>
            <el-tag type="success" size="mini" v-if="scope.row.rank == 4">A量</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="state" width="100px" label="状态"> </el-table-column>

        <el-table-column prop="remark" label="跟进情况"> </el-table-column>
        <el-table-column label="操作" fixed="right" width="65px" v-has-permission-code-and="'100000150085'">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button type="text" v-show="scope.row.id" v-has-permission-code-and="'100000150085'"
                @click="remove(scope.$index, scope.row)" size="mini">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <div slot="footer" style="text-align: center">
      <el-button :type="prebtn" size="medium" round :loading="confirmLoading" @click="move(-1)">{{ prebtn == "primary"
    ?
    "上一条" : "--end--" }}</el-button>
      <el-button type="danger" @click="close">关 闭</el-button>


      <el-button :type="nextbtn" size="medium" round :loading="confirmLoading" @click="move(1)">{{ nextbtn ==
    "primary"
    ? "下一条" : "--end--" }}</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/consu/consultation/consultation.js";
import apircd from "@/api/consu/consultationrecord/consultationrecord.js";
import constant from "@/util/constant.js";


export default {
  name: "advc",
  components: {
    popup
  },
  data() {
    return {
      baseUrl: constant.serverUrl,
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      formParameter: {},
      parameter: [],
      rules: {},
      me: {},

      listConus: [],
      idx: 0,
      sizeConus: 1,
      prebtn: "info",
      nextbtn: "primary",

      listRecords: [],

    };
  },
  methods: {
    updated(){
      let param = {id:this.formParameter.id,sex:this.formParameter.sex,post:this.formParameter.post,
        schoolid:this.formParameter.schoolid,grade:this.formParameter.grade,subject:this.formParameter.subject,
        gradedate:this.formParameter.gradedate,remark:this.formParameter.remark}
      api.update(param,res=>{
        this.$utils.msg.success(res.msg);
      },err=>{
        this.$utils.msg.warning(err.msg);
      })

    },
    move(flag) {
      if (
        (flag < 0 && this.idx > 0) ||
        (flag > 0 && (this.idx + 1) < this.sizeConus)
      ) {
        this.idx += flag;

        if (this.idx == 0) {
          this.prebtn = "info";
        } else if ((this.idx + 1) == this.sizeConus) {
          this.nextbtn = "info";
        } else {
          this.prebtn = "primary";
          this.nextbtn = "primary";
        }
        this.confirmLoading = true;
        this.formParameter = this.listConus[this.idx]
        this.formParameter.vdate = new Date();
        this.parameter = [this.formParameter];

        apircd.list({ coid: this.parameter[0].id }, (res) => {
          if (res.data.records) {
            this.listRecords = res.data.records;
            if (this.listRecords) {
              this.sizeRecord = this.listRecords.length;
              if (this.listRecords[0] && this.listRecords[0].city) {
                this.$set(this.parameter[0], "city", this.listRecords[0].city)
              }
              this.$forceUpdate()
            }
          }
          this.confirmLoading = false;
        });
      }
    },
    //打开弹框
    open(pageDatas, indx, title, me, disabled, size) {

      this.me = me
      this.listConus = pageDatas
      this.idx = indx
      this.sizeConus = pageDatas.length
      this.formParameter = this.listConus[this.idx]
      this.parameter = [this.formParameter];

      this.disabled = disabled;
      this.$refs.popup.open(title, "75%");
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.votes = [];
      this.$refs.popup.close();
    }, //删除
    remove(index, row) {
      let parameter = {
        ids: row.id,
      };

      if (row.uid == this.me.name || (this.me.role == "ad" || this.me.role == "mg")) {
      } else {
        this.$utils.msg.warning("只能删除自己的");
        return false;
      }

      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        apircd.remove(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.listRecords.splice(index, 1);
            this.sizeRecord--;
            this.$parent.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //提交表单
    confirm() {
      this.confirmLoading = true;

      let ids = []
      let ranks = []
      let remarks = []
      let states = []
      let cities = []

      console.log(" this.parameter", this.parameter)

      this.parameter.forEach(element => {
        ids.push(element.id)
        ranks.push(element.rank)
        remarks.push(element.txt)
        states.push(element.state)
        cities.push(element.city)
      });

      let param = {
        ids: ids,
        vdate: this.formParameter.interviewtime,
        ranks: ranks,
        remarks: remarks,
        states: states,
        cities: cities
      };

      api.dody(
        param,
        (response) => {
          this.$utils.msg.success(response.msg);
          this.confirmLoading = false;
          this.close();
          this.$emit("flush");
        },
        (response) => {
          this.$utils.msg.warning(response.msg);
          this.confirmLoading = false;
        }
      );
    },
    init() {
      //清除等待
      this.confirmLoading = false;

      apircd.list({ coid: this.parameter[0].id }, (res) => {
        if (res.data.records) {
          this.listRecords = res.data.records;
          if (this.listRecords) {
            this.sizeRecord = this.listRecords.length;
            if (this.listRecords[0] && this.listRecords[0].city) {
              this.$set(this.parameter[0], "city", this.listRecords[0].city)

            }
          }
        }
      });

      //清空内容
      //清楚校验
      this.$refs.form.clearValidate();
      this.popupLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
